import React from "react";

const Logo = ({ size = 40, withWord = true, className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-label="Tingadya Travels logo" role="img">
      <rect width="64" height="64" rx="14" fill="#0A0A0B" stroke="#D4AF37" strokeOpacity="0.5" />
      <path d="M12 44 L28 20 L38 33 L44 25 L54 44 Z" fill="#D4AF37" />
      <circle cx="46" cy="17" r="4" fill="#F8FAFC" />
      <path d="M16 50 H48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeOpacity="0.6" />
    </svg>
    {withWord && (
      <span className="flex flex-col leading-none">
        <span className="font-display text-lg font-bold tracking-wide text-white">TINGADYA</span>
        <span className="font-mono text-[10px] font-medium uppercase tracking-widest2 text-gold">Travels</span>
      </span>
    )}
  </span>
);

export default Logo;
